import React, { useState } from "react";
import cssClasses from "./KYCAgreementForm.module.css";
import { Tab, Tabs } from "@mui/material";
import BankDetails from "./BankDetails/BankDetails";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import actions from "../../Redux Store/actions";
import { useDispatch } from "react-redux";
import ParkingMasters from "../ParkingMasters/ParkingMasters";
import HoldMaster from "../HoldMasters/HoldMasters";
import CpSourceSettings from "../Settings/CpSourceSettings/CpSourceSettings";
// import AddHoldDetailsModal from "../Project/HoldPageDetails/AddHoldDetailsModal";

const KYCAgreementForm = () => {
  const loggedInUser = useSelector((state) => state.Auth.user);
  const [tabValue, setTabValue] = useState();
  const [tabs, setTab] = useState([]);
  const tabChange = (event, newValue) => {
    setTabValue(newValue);
  };
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(actions.activeMenu("settings"));
  }, []);

  useEffect(() => {
    const payload = []
    if (loggedInUser?.roleId?.level == 1 || loggedInUser?.roleId?.accessibleTabs?.["Settings"]?.["Masters"]?.["KYC Agreement Form"]?.isAccessible) {
      payload.push("KYC Agreement Form");
    }
    if (loggedInUser?.roleId?.level == 1 || loggedInUser?.roleId?.accessibleTabs?.["Settings"]?.["Masters"]?.["Parking"]?.isAccessible) {
      payload.push("Parking");
    }
        if (loggedInUser?.roleId?.level == 1 || loggedInUser?.roleId?.accessibleTabs?.["Settings"]?.["Masters"]?.["Hold"]?.isAccessible) {
      payload.push("Hold");
    }
    if (loggedInUser?.roleId?.level == 1 || loggedInUser?.roleId?.accessibleTabs?.["Settings"]?.["Masters"]?.["CP Source"]?.isAccessible) {
      payload.push("CP Source");
    }
    setTab(payload)
    setTabValue(payload[0])
  },[loggedInUser])

  const tabList = tabs.map((each, index) => {
    return (
      <Tab
        label={each}
        key={index}
        value={each}
        sx={[
          {
            fontFamily: "Inter-Medium !important",
            fontStyle: "normal !important",
            fontWeight: "500 !important",
            fontSize: "1.4rem !important",
            lineHeight: "2rem !important",
            textTransform: "none !important",
          },
        ]}
      />
    );
  });
  return (
    <div className={cssClasses.wrapperPage}>
      <Tabs
        value={tabValue}
        onChange={tabChange}
        variant="scrollable"
        scrollButtons="auto"
        aria-label="scrollable auto tabs example"
        sx={[
          {
            borderBottom: "1px solid #EAECF0 !important",
          },
        ]}
      >
        {tabList}
      </Tabs>

      <div className={cssClasses.wrapperContent}>
        {tabValue === "KYC Agreement Form" && <BankDetails />}
        {tabValue === "Parking" && <ParkingMasters/>}
        {tabValue === "Hold" && <HoldMaster/>}
        {tabValue === "CP Source" && <CpSourceSettings/>}
      </div>
    </div>
  );
};

export default KYCAgreementForm;
